<template>
    <div>
        <div class="kgr-row"></div>
        <kgr-loader inline v-if="loading" />

        <kgr-note-box text-key="MailDeliveries.club.info" />
        <div class="kgr-row"></div>

        <kgr-table v-if="!loading && mailDeliveries.length > 0">
            <thead>
                <tr class="kgr-table__row">
                    <kgr-th sortable>
                        {{ $t('E-Mail') }}
                    </kgr-th>
                    <kgr-th sortable>
                        {{ $t('Datum') }}
                    </kgr-th>
                    <kgr-th sortable>
                        {{ $t('Grund') }}
                    </kgr-th>
                    <kgr-th sortable>
                        {{ $t('Typ') }}
                    </kgr-th>
                    <kgr-th sortable>
                        {{ $t('Name') }}
                    </kgr-th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(mailDelivery, number) in mailDeliveries" :key="number" class="kgr-table__row">
                    <td class="kgr-table__cell no_wrap">
                        {{ mailDelivery.email }}
                    </td>
                    <td class="kgr-table__cell no_wrap">
                        {{ formatDateTime(mailDelivery.bouncedAt) }}
                    </td>
                    <td class="kgr-table__cell no_wrap">
                        {{ mailDelivery.reason }}
                    </td>
                    <td class="kgr-table__cell no_wrap">
                        {{ mailDelivery.userType }}
                    </td>
                    <td class="kgr-table__cell no_wrap">
                        {{ mailDelivery.userName }}
                    </td>
                </tr>
            </tbody>
        </kgr-table>

        <kgr-empty-data
            v-if="!loading && mailDeliveries.length === 0"
            :value="$t('Aktuell gibt es keine problematischen E-Mails in Ihrer Einrichtung.')"
        />
    </div>
</template>

<script>
import EmptyData from '../../components/common/EmptyData.vue';
import Loader from '../../components/common/Loading.vue';
import MailDeliveryRepository from '../../js/repository/MailDeliveryRepository';
import NoteBox from '../../components/common/NoteBox.vue';
import moment from 'moment/moment';

export default {
    components: {
        'kgr-empty-data': EmptyData,
        'kgr-loader': Loader,
        'kgr-note-box': NoteBox,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            mailDeliveries: [],
            loading: true,
        };
    },
    created() {
        MailDeliveryRepository.findAllByClub(this.clubId)
            .then((response) => {
                this.mailDeliveries = response;
                this.loading = false;
            })
            .catch(() => {
                this.$notify.error('Daten konnten nicht geladen werden');
                this.loading = false;
            });
    },
    methods: {
        formatDateTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY: HH:mm');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.no_wrap {
    white-space: nowrap;
}
.dataTable {
    width: 100%;
}
</style>
